<template>
    <section :id="`element-${settings.id}`" class="elle-highlights padd-v" :style="{ backgroundColor: settings?.color }">
        <UiHeadlineContent
            :settings="{
                label: settings?.label,
                headline: settings?.headline,
                content: settings?.body
            }"
        />

        <LoopsHighlights
            v-if="settings?.professionalItems?.length || settings?.highlightItems?.length"
            :highlights="[...(settings?.professionalItems || []), ...(settings?.highlightItems || [])]"
        />
    </section>
</template>

<script setup lang="ts">
defineProps({
    settings: {
        type: Object,
        default: () => ({})
    }
});
</script>
